import React from "react";

function EnquiryForm({ onClose }) {
  return (
    <div className="h-full text-white overflow-y-scroll px-6 py-10 lg:px-16 lg:py-20">
      <div className="flex justify-between items-start mb-10">
        <p className="text-lg max-w-md pt-20">
          Submit your details below and an ARKBUILD consultant will be in touch.
        </p>
        <button
          onClick={onClose}
          className="text-base font-semibold hover:bg-[#282828] bg-[#0d0d0d] w-10 h-10 rounded-full mt-16  transition duration-700 ease-in-out"
        >
          ✕
        </button>
      </div>

      <form className="space-y-6">
        <input
          placeholder="Name*"
          className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded"
        />
        <input
          placeholder="Phone Number*"
          className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded"
        />
        <input
          placeholder="Email Address*"
          className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded"
        />
        <select className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded">
          <option>Type of Work?*</option>
          <option>New Build</option>
          <option>Renovation</option>
          <option>Fitout</option>
          <option>Other</option>
        </select>
        <select className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded">
          <option>How did you hear about us?*</option>
          <option>Instagram</option>
          <option>Facebook</option>
          <option>TikTok</option>
          <option>Signage</option>
          <option>Word of Mouth</option>
          <option>Other</option>
        </select>
        <select className="w-full bg-transparent border border-gray-600 px-4 py-3 rounded">
          <option>Do you have a budget in mind?*</option>
          <option>$10,000-$50,000</option>
          <option>$50,001-$500,000</option>
          <option>$500,001-$1,000,000</option>
          <option>$1,000,001-$2,000,000</option>
          <option>$2,0000,000+</option>
        </select>
        <label className="flex items-start gap-2 text-xs">
          <input type="checkbox" className="" />I consent to receive updates
          about ARKBUILD products and services.
        </label>
        <button
          type="submit"
          className="w-full bg-white text-black py-3 rounded hover:opacity-80"
        >
          Submit Enquiry
        </button>
      </form>
    </div>
  );
}

export default EnquiryForm;
